import React from 'react';
import styles from './EnterpriseFeatures.module.css';

const features = [
  {
    icon: '🔄',
    title: 'New Development',
    description: 'Build new applications and services with AI-powered development assistance, reducing time-to-market by up to 70% while maintaining high code quality.',
    details: [
      'AI-driven architecture recommendations',
      'Automated code generation',
      'Smart testing strategies',
      'Best practices implementation'
    ]
  },
  {
    icon: '🚀',
    title: 'Migration and Modernization',
    description: 'Seamlessly modernize legacy systems and migrate applications to new platforms with intelligent automation and minimal risk.',
    details: [
      'Legacy code analysis and refactoring',
      'Cloud migration assistance',
      'Architecture modernization',
      'Automated dependency updates'
    ]
  },
  {
    icon: '⚡',
    title: 'Developer Productivity',
    description: 'Boost developer efficiency with AI-powered tools that automate routine tasks and provide intelligent suggestions.',
    details: [
      'Smart code completion',
      'Automated documentation',
      'Intelligent debugging',
      'Performance optimization tips'
    ]
  },
  {
    icon: '🛡️',
    title: 'Bugs and Security Vulnerabilities',
    description: 'Proactively identify and fix bugs and security vulnerabilities using advanced AI analysis and real-time monitoring.',
    details: [
      'Automated security scanning',
      'Real-time vulnerability detection',
      'Smart bug prediction',
      'Security best practices enforcement'
    ]
  },
  {
    icon: '📊',
    title: 'Reducing Tech Debt',
    description: 'Systematically identify and eliminate technical debt while improving code quality and maintainability.',
    details: [
      'Code quality analysis',
      'Refactoring suggestions',
      'Architecture optimization',
      'Dependency management'
    ]
  },
  {
    icon: '⚙️',
    title: 'DevOps & SRE Excellence',
    description: 'Enhance your DevOps practices and Site Reliability Engineering with AI-powered automation and insights.',
    details: [
      'Infrastructure as Code optimization',
      'Automated CI/CD pipeline improvements',
      'Intelligent monitoring and alerting',
      'Disaster recovery automation'
    ]
  }
];

const EnterpriseFeatures: React.FC = () => {
  return (
    <section className={styles.section} id="enterprise">
      <div className={styles.container}>
        <div className={styles.header}>
          <h2 className={styles.title}>How global enterprises are leveraging Ana?</h2>
          <p className={styles.subtitle}>
            Discover how leading organizations are transforming their development processes with Ana's enterprise-grade capabilities
          </p>
        </div>

        <div className={styles.featuresGrid}>
          {features.map((feature, index) => (
            <div key={index} className={styles.featureCard}>
              <div className={styles.cardHeader}>
                <div className={styles.iconWrapper}>
                  <span className={styles.icon}>{feature.icon}</span>
                </div>
                <h3>{feature.title}</h3>
              </div>
              <p className={styles.description}>{feature.description}</p>
              <ul className={styles.detailsList}>
                {feature.details.map((detail, detailIndex) => (
                  <li key={detailIndex}>
                    <span className={styles.arrow}>→</span>
                    {detail}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default EnterpriseFeatures;
